import { AxiosInstance } from 'axios'
import { axiosInstance as v1Axios } from 'src/utils/request'
import { axiosInstance as v2Axios } from 'src/utils/requestV2'

export interface ApiClient {
  get<T>(url: string, params?: Record<string, any>): Promise<T>
  post<T>(url: string, data?: unknown, params?: Record<string, any>): Promise<T>
  put<T>(url: string, data?: unknown, params?: Record<string, any>): Promise<T>
  patch<T>(
    url: string,
    data?: unknown,
    params?: Record<string, any>,
  ): Promise<T>
  del<T>(
    url: string,
    config?: { params?: Record<string, any>; data?: unknown },
  ): Promise<T>
}

function wrapAxios(instance: AxiosInstance): ApiClient {
  return {
    get: async <T>(url: string, params?: Record<string, any>) => {
      const res = await instance.get<T>(url, { params })
      return res.data
    },
    post: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await instance.post<T>(url, data, { params })
      return res.data
    },
    put: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await instance.put<T>(url, data, { params })
      return res.data
    },
    patch: async <T>(
      url: string,
      data?: unknown,
      params?: Record<string, any>,
    ) => {
      const res = await instance.patch<T>(url, data, { params })
      return res.data
    },
    del: async <T>(
      url: string,
      config?: { params?: Record<string, any>; data?: unknown },
    ) => {
      const res = await instance.delete<T>(url, config)
      return res.data
    },
  }
}

export const v1Client = wrapAxios(v1Axios)
export const v2Client = wrapAxios(v2Axios)
